module.exports = {
  __depends__: [
    require(162),
    require(233),
    require(227)
  ],
  create: [ 'type', require(156) ]
};
